import AWS from "aws-sdk";
import { cognitoConfig } from "../config/awsConfig";
import { jwtDecode } from 'jwt-decode'; // Install this library using npm install jwt-decode

const cognitoIdentity = new AWS.CognitoIdentityServiceProvider({
  region: cognitoConfig.region,
});

// Sign Up
export async function signUp(username, password, email) {
  const params = {
    ClientId: cognitoConfig.clientId,
    Username: username,
    Password: password,
    UserAttributes: [{ Name: "email", Value: email }],
  };

  try {
    const response = await cognitoIdentity.signUp(params).promise();
    console.log("Sign Up Success:", response);
    return response;
  } catch (error) {
    console.error("Sign Up Error:", error);
    throw error;
  }
}

// Confirm Sign Up
export async function confirmSignUp(username, code) {
  const params = {
    ClientId: cognitoConfig.clientId,
    Username: username,
    ConfirmationCode: code,
  };

  try {
    const response = await cognitoIdentity.confirmSignUp(params).promise();
    console.log("Confirm Sign Up Success:", response);
    return response;
  } catch (error) {
    console.error("Confirm Sign Up Error:", error);
    throw error;
  }
}

// Sign In
export async function signIn(username, password) {
  const params = {
    AuthFlow: "USER_PASSWORD_AUTH",
    ClientId: cognitoConfig.clientId,
    AuthParameters: {
      USERNAME: username,
      PASSWORD: password,
    },
  };

  try {
    const response = await cognitoIdentity.initiateAuth(params).promise();
    const { IdToken, AccessToken, RefreshToken } = response.AuthenticationResult;

    console.log("Sign In Success:", response);

    // Decode the ID token to extract the email
    const decodedIdToken = jwtDecode(IdToken);
    const email = decodedIdToken.email;

    localStorage.setItem("authToken", AccessToken);

    // Return tokens for use in API calls
    return { IdToken, AccessToken, RefreshToken, email };
  } catch (error) {
    console.error("Sign In Error:", error);
    throw error;
  }
}

// Refresh Token
export const refreshTokenFunc = async (refreshTokenValue) => {
  const params = {
    AuthFlow: "REFRESH_TOKEN_AUTH",
    ClientId: cognitoConfig.clientId,
    AuthParameters: {
      REFRESH_TOKEN: refreshTokenValue
    },
  };

  try {
    const response = await cognitoIdentity.initiateAuth(params).promise();
    const { AccessToken, RefreshToken, ExpiresIn, IdToken } = response.AuthenticationResult;

    // Decode the ID token to extract the email
    const decodedIdToken = jwtDecode(IdToken);
    const email = decodedIdToken.email;

    localStorage.setItem("authToken", AccessToken);

    return {AccessToken, RefreshToken, ExpiresIn, email};
  } catch (error) {
      console.log("Failed to refresh token:", error)
      throw new Error(`Failed to refresh token: ${error}`);
  }
};
